module.exports = __webpack_public_path__ + "static/media/android_store.90ce95f8.jpg";